
import { defineComponent } from 'vue';
import Incentives from '../Incentives/Incentives.vue';
import LeftContentContainer from './LeftContentContainer.class';
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	components: {
		Incentives,
	},
	emits: ['notNow', 'accept'],
	setup: (_, { emit }) => {
		const component = new LeftContentContainer(emit);
		return setupComponent(component);
	},
});
